import React from "react";

export const ZeroPaymentsSummarySection = ({
  formData,
  accompanyingPersons,
  accompanyingPersonFee,
  focusedSessions,
  focusedSessionFees,
  selectedFocusedSessions,
}) => {
  const freeItems = [];

  if (formData.zeroPayments && Array.isArray(formData.zeroPayments)) {
    formData.zeroPayments.forEach((zeroPayment) => {
      freeItems.push({
        name: zeroPayment.name,
        type: "Saved",
        isPaid: true,
        createdDate: zeroPayment.createdDate,
      });
    });
  }

  if (accompanyingPersonFee && parseFloat(accompanyingPersonFee.rate) === 0) {
    const paidAccompanyingPersons = formData.additionalFees
      ? formData.additionalFees.filter(
          (fee) => fee.feeTypeId === accompanyingPersonFee.id
        )
      : [];
    const allAccompanyingPersons = [
      ...paidAccompanyingPersons.map((paid) => ({
        name: paid.name,
        isPaid: true,
      })),
      ...accompanyingPersons
        .filter(
          (person) =>
            !paidAccompanyingPersons.some((fee) => fee.name === person.name)
        )
        .map((person) => ({
          name: person.name,
          isPaid: false,
        })),
    ];

    allAccompanyingPersons.forEach((person) => {
      const alreadyInZeroPayments = formData.zeroPayments.some(
        (zeroPayment) => zeroPayment.name === person.name
      );
      if (!alreadyInZeroPayments) {
        freeItems.push({
          name: person.name,
          type: "Accompanying Person",
          isPaid: person.isPaid,
        });
      }
    });
  }

  const paidFocusedSessions = formData.additionalFees
    ? formData.additionalFees.filter(
        (fee) =>
          !accompanyingPersonFee || fee.feeTypeId !== accompanyingPersonFee.id
      )
    : [];
  const allFocusedSessionIds = [
    ...paidFocusedSessions.map((fee) => fee.feeTypeId),
    ...selectedFocusedSessions.filter(
      (sessionId) =>
        !paidFocusedSessions.some((paid) => paid.feeTypeId === sessionId)
    ),
  ];

  allFocusedSessionIds.forEach((sessionId) => {
    const session = focusedSessions.find((item) => item.id === sessionId);
    const sessionFee = focusedSessionFees[sessionId];
    const isPaid = paidFocusedSessions.some(
      (paid) => paid.feeTypeId === sessionId
    );
    const sessionName = session ? session.value : `Session ${sessionId}`;

    if (sessionFee && parseFloat(sessionFee.rate) === 0) {
      const alreadyInZeroPayments =
        formData.zeroPayments &&
        formData.zeroPayments.some((zeroPayment) => zeroPayment.name === sessionName);
      if (!alreadyInZeroPayments) {
        freeItems.push({
          name: sessionName,
          type: "Focused Session",
          isPaid,
        });
      }
    }
  });

  if (freeItems.length === 0) {
    return null;
  }

  return (
    <div
      className="summary-section"
      style={{
        backgroundColor: "#e8f5e9",
        padding: "15px",
        marginTop: "10px",
        borderRadius: "5px",
        border: "1px solid #4caf50",
      }}
    >
      <h4 style={{ color: "#2e7d32", marginBottom: "10px" }}>
        <span style={{ marginRight: "8px" }}>🆓</span>
        Zero Payments (Free Items)
      </h4>
      {freeItems.map((item, index) => (
        <div className="summary-row" key={index} style={{ marginBottom: "8px" }}>
          <span className="summary-label">
            {item.name}
            <span
              style={{
                marginLeft: "8px",
                fontSize: "11px",
                color: "#666",
                fontStyle: "italic",
              }}
            >
              ({item.type})
            </span>
          </span>
          <span
            className="summary-value"
            style={{ color: "#2e7d32", fontWeight: "bold" }}
          >
            FREE
            {item.isPaid && (
              <span
                style={{
                  marginLeft: "8px",
                  color: "#28a745",
                  fontSize: "12px",
                }}
              >
                ✓ Saved
              </span>
            )}
          </span>
        </div>
      ))}
      <div
        className="summary-row"
        style={{
          marginTop: "10px",
          paddingTop: "10px",
          borderTop: "1px solid #4caf50",
        }}
      >
        <span className="summary-label" style={{ fontWeight: "bold" }}>
          Total Free Items:
        </span>
        <span
          className="summary-value"
          style={{ fontWeight: "bold", color: "#2e7d32" }}
        >
          {freeItems.length} item{freeItems.length > 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
};
